// 配列の全ての要素が任意の型か
//
// @param [Array] array 検査対象の配列
// @param [string] type 許可する要素の型
// @return [Boolean]
export function arrayAllTypeOf (array, type) {
  for (const value of array) {
    if (typeof value !== type) {
      return false
    }
  }

  return true
}
